import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { MdLogin } from "react-icons/md";
import logo from "shared/assets/images/logo.svg";
import Button from "shared/components/Button";
import Input from "shared/components/Input";
import { NAME_SPACES } from "shared/locales/constants";
import { bindInputProps } from "utils/helpers/input";
import validation from "./validation";

const View = ({ onSubmit, onLinkClick }) => {
  const { t: auth } = useTranslation(NAME_SPACES.AUTH);
  const { t: errors } = useTranslation(NAME_SPACES.ERRORS);
  const SIGN_IN = auth("SIGN_IN", {
    returnObjects: true,
  });
  const VALIDATIONS = errors("VALIDATIONS", {
    returnObjects: true,
  });
  return (
    <div className="auth">
      <img alt="logo" src={logo} />
      <Formik
        initialValues={{ password: "" }}
        onSubmit={onSubmit}
        validationSchema={validation(VALIDATIONS)}
        validateOnBlur
        validateOnChange={false}
      >
        {({ isValid, handleSubmit, ...formProps }) => (
          <div className="auth__body">
            <Input
              label={SIGN_IN.EMAIL}
              placeholder={SIGN_IN.EMAIL}
              {...bindInputProps({
                name: "username",
                ...formProps,
              })}
            />
            <Input
              type="password"
              label={SIGN_IN.PASSWORD}
              placeholder={SIGN_IN.PASSWORD}
              {...bindInputProps({
                name: "password",
                ...formProps,
              })}
            />
            <Button type="primary" onClick={handleSubmit}>
              {SIGN_IN.SUBMIT}
              <MdLogin size={16} />
            </Button>
          </div>
        )}
      </Formik>
      <span className="auth__link" onClick={onLinkClick}>
        {SIGN_IN.LINK}
      </span>
    </div>
  );
};

export default View;
